import * as angular from 'angular';

export class Controller {

    $onInit() {
        this.settings = angular.copy(this.resolve.settings);
    }

    save() {
        this.close({$value: this.settings})
    }

    notModified() {
        const neu = this.settings;
        const old = this.resolve.settings;
        return ['companyName', 'website', 'phoneNumber', 'phoneNumber2']
            .every((prop) => !neu[prop] && !old[prop] || neu[prop] === old[prop]);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/corporate-settings/company-profile/edit-profile/edit-profile.controller.js